import { render, staticRenderFns } from "./kpi-d-edit.vue?vue&type=template&id=6d2bb7e0&scoped=true"
import script from "./kpi-d-edit.vue?vue&type=script&lang=ts"
export * from "./kpi-d-edit.vue?vue&type=script&lang=ts"
import style0 from "./kpi-d-edit.vue?vue&type=style&index=0&id=6d2bb7e0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2bb7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d2bb7e0')) {
      api.createRecord('6d2bb7e0', component.options)
    } else {
      api.reload('6d2bb7e0', component.options)
    }
    module.hot.accept("./kpi-d-edit.vue?vue&type=template&id=6d2bb7e0&scoped=true", function () {
      api.rerender('6d2bb7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/performance-assessment/kpi-d/kpi-d-edit.vue"
export default component.exports